<template>

  <div class="stages-detail-page">
    <Header></Header>
    <section class="stg-detail-section">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="stg-detail-blk">
              <div class="stg-art-img background-fit" :style="{ backgroundImage: `url(${imageUrl + profileImage})` }"></div>
              <div class="stg-art-detail">
                <h3>{{title}}</h3>
                <p><span>By {{name}}</span><span></span><span>{{date | formatDate}}</span></p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <!--<video-player v-if="videoImage"  class="video-player-box stg-detail-i"-->
                           <!--ref="videoPlayer"-->
                           <!--:options="playerOptions"-->
                           <!--:playsinline="true"-->
                           <!--customEventName="customstatechangedeventname"-->

                           <!--@play="onPlayerPlay($event)"-->
                           <!--@pause="onPlayerPause($event)"-->
                           <!--@statechanged="playerStateChanged($event)"-->
                           <!--@ready="playerReadied">-->
            <!--</video-player>-->
            <iframe class="stg-detail-i" style="width: 100%" v-if="youtubeF" :src="`https://www.youtube.com/embed/`+youtubeurl" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            <!--<div class="stg-detail-i background-fit" :style="{ backgroundImage: `url(${imageUrl + videoImage})` }"></div>-->
            <iframe class="stg-detail-i" style="width: 100%" v-if="!youtubeF" :src="`https://player.vimeo.com/video/`+youtubeurl" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
          </div>
        </div>
        <div class="row row-3 flex-column-reverse flex-sm-row">
          <div class="col-md-6">
            <h3>Stage Description</h3>
            <p>
              {{description}}
            </p>
          </div>
          <div class="col-md-6">
            <h3>Tags</h3>
            <p>
              <span class="tags" v-for="(list) in tags" v-bind:key="list.id">{{list}}<i>,</i> </span>
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="stages-section">
      <div class="container">
        <div class="row row-1">
          <div class="col-md-12">
            <h2>Recommended Stages</h2>
          </div>
        </div>
      </div>
    </section>
    <section class="stg-section">
      <div class="container">
        <div class="row row-2">
          <router-link class="col-md-6 fc-col background-fit" :to="`/stage/` + stage._id" v-for="(stage) in RecommendedStages" v-bind:key="stage.id" :style="{ backgroundImage: `url(${imageUrl + stage.videoId[0].videoImageFile})` }">
            <div class="inner-blk">
              <div class="i-blk">
                <div class="profile-p background-fit" :style="{ backgroundImage: `url(${imageUrl + stage.userId[0].profiles[0].images[0].profileImageFile})` }"></div>
                <div class="p-detail">
                  <h3>{{stage.title}}</h3>
                  <p>{{stage.created | formatDate}}</p>
                  <span><img src="@/assets/img/next-arrow.svg"/></span>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './Header'
import Footer from './Footer'
import router from '../router'
import axios from 'axios'
import backgroundUrl from '@/assets/img/image6.jpg'
import backgroundUrl2 from '@/assets/img/image1.jpg'
import backgroundUrl1 from '@/assets/img/team/dasha.png'
import backgroundUrl4 from '@/assets/img/image4.jpg'
import backgroundUrl5 from '@/assets/img/image5.svg'
import Vue from 'vue'
// import 'video.js/dist/video-js.css'
// import { videoPlayer } from 'vue-video-player'

export default {
  name: 'StageDetail',
  components: {
    'Header': Header,
    'Footer': Footer
  },
  mounted () {
      axios
          .get('/getStageById', {
              params: {
                  stageId: this.stageId
              }
          })
          .then(response => {
              this.title = response.data.title
              this.date = response.data.created
              this.name = response.data.userId[0].name
              this.profileImage = response.data.userId[0].profiles[0].images[0].profileImageFile
              // this.videoImage = this.imageUrl + response.data.videoId[0].videoImageFile
              // this.video = this.imageUrl + response.data.videoId[0].videourl
              this.description = response.data.description
              this.tags = response.data.tags

              if(response.data.youtubeurl){
                  if(response.data.youtubeurl.includes('youtube')){
                      let uri = response.data.youtubeurl.split('?')
                      if (uri.length == 2)
                      {
                          let vars = uri[1].split('&')
                          let getVars = {}
                          let tmp = ''
                          vars.forEach(function(v){
                              tmp = v.split('=')
                              if(tmp.length == 2)
                                  getVars[tmp[0]] = tmp[1]
                          })
                          this.youtubeF = true
                          this.youtubeurl = getVars.v
                          // do
                      }
                  } else if(response.data.youtubeurl.includes('vimeo')){
                      this.youtubeF = false
                      let uri = response.data.youtubeurl.split('/')
                      this.youtubeurl = uri[uri.length - 1]
                  }
              }


              // this.playerOptions = {
              //     // videojs options
              //     muted: false,
              //     language: 'en',
              //     playbackRates: [0.7, 1.0, 1.5, 2.0],
              //     sources: [{
              //         type: "video/mp4",
              //         src: this.video
              //     }],
              //     poster: this.videoImage
              // }
          })
          .catch(error => console.log(error))

      axios
          .get('/getRecommendedStages', {
              params: {
                  stageId: this.stageId
              }
          })
          .then(response => {
              this.RecommendedStages = response.data
          })
          .catch(error => console.log(error))
  },
  data () {
    return {
        backgroundUrl: backgroundUrl,
        backgroundUrl1: backgroundUrl1,
        backgroundUrl2: backgroundUrl2,
        backgroundUrl4: backgroundUrl4,
        backgroundUrl5: backgroundUrl5,
        stageId: router.history.current.params.id,
        title: '',
        name: '',
        date: '',
        videoImage: backgroundUrl2,
        profileImage: '',
        description: '',
        video: '',
        youtubeF: true,
        tags: '',
        imageUrl: process.env.imageUrl,
        RecommendedStages: '',
        msg: 'Welcome to Your Vue.js App',
        playerOptions: ''
    }
  },
  computed: {
      // player() {
      //     return this.$refs.videoPlayer.player
      // }
  },
  methods: {
      // listen event
      // onPlayerPlay(player) {
      //     console.log('player play!', player)
      // },
      // onPlayerPause(player) {
      //     console.log('player pause!', player)
      // },
      // // ...player event
      //
      // // or listen state event
      // playerStateChanged(playerCurrentState) {
      //     console.log('player current update state', playerCurrentState)
      // },
      //
      // // player is ready
      // playerReadied(player) {
      //     console.log('the player is readied', player)
      //     // you can use it to do something...
      //     // player.[methods]
      // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/StageDetail.vue